export default "__VITE_ASSET__05986ef8__"